import Vue from "vue";
import Router from "vue-router";
import ViewUI from "view-design";
import { getToken, canTurnTo, setToken } from "../utils/util";
import routes from "./router";
import store from "@/store";
// console.log(store);
Vue.use(Router);
// setToken("ab2c8mc3znBjdvYN0QbHP13PVjXWRxEYY8cQBig1MJiI5kg07otfG_DC");
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "global-tabs-bar-active",
  routes
});

const LOGIN_NAME = "login";

const turnTo = (to, access, next) => {
  if (canTurnTo(to, access, routes)) {
    next();
  } else {
    next({
      name: "error_401",
      replace: true
    });
  }
};

router.beforeEach((to, from, next) => {
  ViewUI.LoadingBar.start();
  const token = getToken();
  if (to.name === "error_500") {
    next();
  }
  if (!token && to.name !== LOGIN_NAME) {
    //没有登录且跳转的不是登录页，跳转到登录页
    next({
      name: LOGIN_NAME //跳转到登录页
    });
  } else if (!token && to.name === LOGIN_NAME) {
    //没有登录且跳转的是登录页，直接跳转
    next();
  } else if (token && to.name === LOGIN_NAME) {
    //已登录且要跳转的是登录页
    next({
      name: "group" //跳转到保修首页
    });
  } else {
    next();
    // if (store.state.user.hasGetInfo) {
    //   //如果有用户信息
    //   turnTo(to, store.state.user.permissionList, next);
    // } else {
    //   store.dispatch("getUserInfo").then(res => {
    //     turnTo(to, res.power, next);
    //     // console.log(res);
    //     next();
    //   });
    // }
  }
});

router.afterEach(() => {
  ViewUI.LoadingBar.finish();
});

export default router;
